module.exports = "/_next/static/images/c4e94aa98b7553a24059084218de80c6-comunidad-nu-xs.jpg";